@if (visible) {

<p-button
    icon="pi pi-info-circle"
    type="button"
    [rounded]="true"
    [text]="true"
    (click)="mfaInfo.toggle($event)">
</p-button>

<p-popover #mfaInfo>
    <div class="p-4" style="max-width: 480px;">

        <div class="text-xl font-bold mb-4 text-900">
            <i class="pi pi-shield mr-2 text-primary"></i>
            Double authentification (MFA)
        </div>

        <div class="flex flex-column gap-4">

            <!-- Qu'est-ce que c'est -->
            <div class="surface-50 border-round p-3 border-left-3 border-primary">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-question-circle text-primary text-xl"></i>
                    <span class="font-bold text-lg text-900">C'est quoi ?</span>
                </div>
                <p class="text-700 line-height-3 m-0 pl-4">
                    La double authentification ajoute une deuxième vérification à votre connexion, en plus de votre mot de passe.
                    À chaque connexion, un <strong>code à 6 chiffres valable 30 secondes</strong> vous est demandé.
                    Ce code est généré par une application sur votre téléphone.
                </p>
            </div>

            <!-- Comment ça fonctionne -->
            <div class="surface-50 border-round p-3 border-left-3 border-blue-400">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-mobile text-blue-400 text-xl"></i>
                    <span class="font-bold text-lg text-900">Comment ça marche ?</span>
                </div>
                <div class="pl-4">
                    <p class="text-700 line-height-3 m-0 mb-2">
                        Lors de votre première connexion sécurisée, vous devrez :
                    </p>
                    <ol class="text-700 line-height-3 m-0 pl-3">
                        <li class="mb-1">Télécharger une application d'authentification sur votre téléphone</li>
                        <li class="mb-1">Scanner un QR Code depuis l'application</li>
                        <li>Saisir le code à 6 chiffres affiché pour confirmer</li>
                    </ol>
                    <p class="text-600 text-sm mt-3 m-0">
                        <i class="pi pi-info-circle mr-1"></i>
                        Applications compatibles : <strong>Google Authenticator</strong>, <strong>Authy</strong>, <strong>Microsoft Authenticator</strong>…
                    </p>
                </div>
            </div>

            <!-- Pourquoi c'est utile -->
            <div class="surface-50 border-round p-3 border-left-3 border-green-500">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-lock text-green-500 text-xl"></i>
                    <span class="font-bold text-lg text-900">Pourquoi c'est important ?</span>
                </div>
                <p class="text-700 line-height-3 m-0 pl-4">
                    Même si votre mot de passe est compromis, un attaquant ne pourra pas accéder à votre compte
                    sans avoir également accès à votre téléphone.
                    C'est une protection essentielle pour les données comptables et financières.
                </p>
            </div>

            <!-- Contexte login : pourquoi c'est obligatoire -->
            @if (loginContext) {
            <div class="surface-50 border-round p-3 border-left-3 border-yellow-400">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-building text-yellow-400 text-xl"></i>
                    <span class="font-bold text-lg text-900">Pourquoi dois-je l'activer ?</span>
                </div>
                <p class="text-700 line-height-3 m-0 pl-4">
                    L'administrateur d'une des sociétés auxquelles vous appartenez a rendu la double authentification
                    obligatoire. Vous devez configurer votre application d'authentification pour accéder à votre compte.
                </p>
            </div>
            }

            <!-- Autres contextes : comment l'activer depuis le profil -->
            @if (!loginContext) {
            <div class="surface-50 border-round p-3 border-left-3 border-yellow-400">
                <div class="flex align-items-center gap-2 mb-2">
                    <i class="pi pi-user text-yellow-400 text-xl"></i>
                    <span class="font-bold text-lg text-900">Comment l'activer ?</span>
                </div>
                <p class="text-700 line-height-3 m-0 pl-4">
                    Vous pouvez configurer la double authentification depuis votre
                    <a routerLink="/user/profile" class="text-primary font-medium no-underline hover:underline">profil utilisateur</a>,
                    dans la section "Double authentification".
                </p>
            </div>
            }

        </div>
    </div>
</p-popover>

}
